<template>
    <vx-selectable
        data-test="category-filter"
        :placeholder="props.placeholder"
        :clearable="false"
        :options="props.options"
        v-model="model"
        :reduce="(option) => option.value"
    >
        <template v-slot:option="{ option }">
            <font-awesome-icon class="mr-2 text-slate-500 text-xs" :icon="option.icon"></font-awesome-icon>
            {{ option.label }}
        </template>
        <template v-slot:selected-option="{ option }">
            <div class="flex items-center">
                <font-awesome-icon class="mr-2 text-slate-500 text-xs" :icon="option.icon"></font-awesome-icon>
                <span class="truncate">{{ option.label }}</span>
            </div>
        </template>
    </vx-selectable>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import { resourceCategoriesOptions } from '~/constants/categories';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const model = defineModel({ required: true });

const props = defineProps({
    placeholder: {
        type: String,
        required: false,
        default: 'Select Category',
    },
    options: {
        type: Array,
        required: false,
        default: resourceCategoriesOptions,
    },
});
</script>
